module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "halo-tree"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nodelabel),
      expression: "nodelabel"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nodelabel)
    },
    on: {
      "click": _vm.toggleShowTree,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nodelabel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.showTree ? 'caret-up' : 'caret-down', _vm.icon],
    on: {
      "click": _vm.toggleShowTree
    }
  })]), _vm._v(" "), _c('tree', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTree),
      expression: "showTree"
    }],
    ref: "tree",
    attrs: {
      "treeData": _vm.treeData,
      "options": _vm.options
    },
    on: {
      "node-click": _vm.nodeclick,
      "handlecheckedChange": _vm.handlecheckedChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ac7d7c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/combotree.vue
// module id = 1074
// module chunks = 159